<template>
	<div class="qwxzs-main">
		<div class="left-menu">
			<div v-for="(item, index) in menuList" :key="index" @click="toPath(index)" class="left-menu-item" :style="{backgroundImage: leftIndex === index ? 'url(../../../static/young_left_select.png)' : ''}">
				<img :src="item.image" >
			</div>
		</div>
		<div class="top-choose-box">
			<img class="zswd" src="../../../static/kpxjt_left_select.png" v-if="topIndex == 0">
			<img class="zswd" src="../../../static/kpxjt_left_unselect.png" v-else @click="changeTop(0)">
			<img class="line" src="../../../static/young_line.png" >
			<img class="zsgl" src="../../../static/kpxjt_right_select.png" v-if="topIndex == 1">
			<img class="zsgl" src="../../../static/kpxjt_right_unselect.png" v-else @click="changeTop(1)">
		</div>
		<img class="back_home" @click="backHome" src="../../../static/back_young_home.png" >

		<div class="left-select" v-if="topIndex === 0">
			<div v-if="kpspIndex == -1" class="kpsp-list">
				<div class="kpsp-main">
					<div class="kpsp-item" v-for="(item, index) in kpspList" :key="index" @click="kpspIndex=index">
						<div class="kpsp-item-top">
							<img :src="$imgUrl + item.listImgPc" class="kpsp-item-top-image">
							<div class="kpsp-item-top-text">
								<div class="kpsp-item-top-text-play">
									<img src="../../../static/play.png" >
								</div>

								<div class="kpsp-item-top-text-title">
									{{item.title}}
								</div>
								<div class="kpsp-item-top-text-content">
									{{item.shortTitle}}
								</div>
							</div>
						</div>
						<div class="kpsp-item-bottom">
							{{item.title}}
						</div>
					</div>
				</div>
				<page v-if="topIndex === 0" :pageObj="params1" @getDataList="getData" ref="page"></page>
			</div>
			<div v-else class="kpsp-details">
				<div class="back" @click="kpspIndex=-1">

				</div>
				<video :src="$imgUrl + kpspList[kpspIndex].video" controls="controls" class="kpsp-details-img video-js"></video>
				<Scroll class="kpsp-details-content" :height="250">
					<div v-html="kpspList[kpspIndex].txt" style="color: #FFFFFF; text-align: left; margin-right: 15px;">

					</div>
				</Scroll>
			</div>
		</div>
		<div class="left-select" v-if="topIndex === 1">
			<div v-if="kpjzIndex == -1" class="kpsp-list">
				<div class="kpsp-main">
					<div class="kpjz-item" v-for="(item, index) in kpjzList" :key="index">
						<div class="kpjz-item-top">
							<video :src="$imgUrl + item.video" controls="controls" class="video-box video-js"></video>
						</div>
						<div class="kpjz-item-bottom">
							<div class="kpjz-item-bottom-left" @click="chooseJz((params2.current - 1) * 3 + index + 1)">
								<img src="../../../static/kpjz_icon.png" >
							</div>
							<div class="kpjz-item-bottom-right" @click="chooseJz((params2.current - 1) * 3 + index + 1)">
								<div class="kpjz-item-bottom-right-1">
									{{item.title}}
								</div>
								<div class="kpjz-item-bottom-right-2">

									<span v-if="item.author">
										主讲人:{{item.author}}
									</span>
									<span>时间: {{$moment(item.releaseTime).format('YYYY-MM-DD')}}</span>
								</div>
								<div class="kpjz-item-bottom-right-3">
									{{item.shortTitle}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<page v-if="topIndex === 1" :pageObj="params2" @getDataList="getData" ref="page"></page>
			</div>
			<div v-else class="kpjz-details">
				<div class="bg_4_left" v-if="showJz.previous" @click="chooseJz(showJz.previous.page)">

					<div style="margin-top: 62px; font-size: 18px;">
						上一期
					</div>
					<div style="width: 60%; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 12px; margin: 0 20%;">
						{{showJz.previous.title}}
					</div>
				</div>
				<div class="bg_4_left_nomore" v-else>

				</div>
				<div class="kpjz-details-middle" v-if="showJz.data">
					<div class="back" @click="kpjzIndex=-1">

					</div>
					<video :src="$imgUrl + showJz.data.video" controls="controls" class="kpsp-details-img video-js"></video>
					<Scroll class="kpsp-details-content" :height="250">
						<div v-html="showJz.data.txt" style="color: #FFFFFF; text-align: left; margin-right: 15px;">

						</div>
					</Scroll>
				</div>
				<div class="bg_4_right" v-if="showJz.next" @click="chooseJz(showJz.next.page)">

					<div style="margin-top: 66px; font-size: 18px;">
						下一期
					</div>
					<div style="width: 60%; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 12px; margin: 0 20%;">
						{{showJz.next.title}}
					</div>
				</div>
				<div class="bg_4_right_nomore" v-else>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: 'qwxzs',
		data () {
			return {
				menuList: [
					{
						path: 'qwzs',
						image: '../../../static/qwxzs.png'
					},
					{
						path: 'xxhj',
						image: '../../../static/xxhj.png'
					},
					{
						path: 'kpxjt',
						image: '../../../static/kpxjt.png'
					},
					{
						path: 'zyzs',
						image: '../../../static/zyzs.png'
					},
					{
						path: 'hdyx',
						image: '../../../static/hdyx.png'
					},
				],
				leftIndex: 2,
				topIndex: 0,
				kpspIndex: -1,
				kpspList: [],
				kpjzIndex: -1,
				kpjzList: [],
				params1: {
					current: 1,
					size: 3,
					channelId: 35,
					releaseTerrace: "releasePc"
				},
				params2: {
					current: 1,
					size: 3,
					channelId: 36,
					releaseTerrace: "releasePc"
				},
				videoElement: [],
				showJz: {
					previous: {},
					next: {},
					data: {}
				}
			}
		},
		components: {
			Page
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.$store.state.showTop = true
		},
		methods: {
			backHome() {
				this.$router.push('young_index')
			},
			toPath(Index) {
				let that = this
				if(Index === 1) {
					this.$Message.info('尚未开放，敬请期待！')
					return
				}
				if(Index != that.leftIndex) {
					that.$router.push(that.menuList[Index].path)
				}
			},
			changeTop(topIndex) {
				let that = this
				that.topIndex = topIndex
				that.kpjzIndex = -1
				that.kpspIndex = -1
				that.$nextTick(function () {
					if(topIndex === 0) {
						that.params1.current = 1
						that.$refs.page.getData()
					} else {
						that.params2.current = 1
						that.$refs.page.getData()
					}
				})
			},
			getData(data) {
				if(this.topIndex === 0) {
					this.kpspList = data
					this.kpspList.forEach(item => {
						item.txt = this.format(item.txt)
					})
				} else {
					this.kpjzList = data
					this.kpjzList.forEach(item => {
						item.txt = this.format(item.txt)
					})
					this.videoElement = document.getElementsByTagName('video')
				}
			},
			format(txt) {
				var html = txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:330px;height:auto;display:inline-block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi, '<video style="width:330px;height:auto;display:inline-block;margin:10rpx auto;"');
				return newContent
			},
			chooseJz(page) {
				let that = this
				that.kpjzIndex = 1
				that.$http.post({
					url: '/api/channel/findContentListByChannelId',
					data: {
						current: page,
						size: 1,
						channelId: 36,
						releaseTerrace: "releasePc"
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.showJz.data = res.data.content[0]
						that.showJz.data.txt = that.format(that.showJz.data.txt)
						if(res.data.previous) {
							that.$http.post({
								url: '/api/channel/findContentListByChannelId',
								data: {
									current: page - 1,
									size: 1,
									channelId: 36,
									releaseTerrace: "releasePc"
								}
							}).then(res => {
								if(res.code === 'S200') {
									that.showJz.previous = res.data.content[0]
									that.showJz.previous.page = page - 1
								}
							})
						} else {
							that.showJz.previous = null
						}
						if(res.data.next) {
							that.$http.post({
								url: '/api/channel/findContentListByChannelId',
								data: {
									current: page + 1,
									size: 1,
									channelId: 36,
									releaseTerrace: "releasePc"
								}
							}).then(res => {
								if(res.code === 'S200') {
									that.showJz.next = res.data.content[0]
									that.showJz.next.page = page + 1
								}
							})
						} else {
							that.showJz.next = null
						}

					}
				})
				// that.$http.post({
				// 	url: '/api/content/getContentUpAndDownById',
				// 	data: {
				// 		id: that.kpjzList[that.kpjzIndex].id,
				// 		channelId: 36,
				// 		releaseTerrace: 'releasePc'
				// 	}
				// }).then(res => {
				// 	if(res.data.previousId) {
				// 		that.$http.post({
				// 			url: '/api/content/getContentUpAndDownById',
				// 			data: {
				// 				id: res.data.previousId,
				// 				channelId: 36,
				// 				releaseTerrace: 'releasePc'
				// 			}
				// 		}).then(ress => {
				// 			that.showJz.previous = {
				// 				id: res.data.previousId,
				// 				title: ress.data.content.title
				// 			}
				// 		})
				// 	} else {
				// 		that.showJz.previous = null
				// 	}
				// 	that.showJz.data = {
				// 		video: res.data.content.video,
				// 		txt: that.format(res.data.content.txt)
				// 	}
				// 	if(res.data.nextId) {
				// 		that.$http.post({
				// 			url: '/api/content/getContentUpAndDownById',
				// 			data: {
				// 				id: res.data.nextId,
				// 				channelId: 36,
				// 				releaseTerrace: 'releasePc'
				// 			}
				// 		}).then(ress => {
				// 			that.showJz.next = {
				// 				id: res.data.nextId,
				// 				title: ress.data.content.title
				// 			}
				// 		})
				// 	} else {
				// 		that.showJz.next = null
				// 	}
				// })
			},
			changeJz(jzId) {
				let that = this
				that.$http.post({
					url: '/api/content/getContentUpAndDownById',
					data: {
						id: jzId,
						channelId: 36,
						releaseTerrace: 'releasePc'
					}
				}).then(res => {
					if(res.data.previousId) {
						that.$http.post({
							url: '/api/content/getContentUpAndDownById',
							data: {
								id: res.data.previousId,
								channelId: 36,
								releaseTerrace: 'releasePc'
							}
						}).then(ress => {
							that.showJz.previous = {
								id: res.data.previousId,
								title: ress.data.content.title
							}
						})
					} else {
						that.showJz.previous = null
					}
					that.showJz.data = {
						video: res.data.content.video,
						txt: that.format(res.data.content.txt)
					}
					if(res.data.nextId) {
						that.$http.post({
							url: '/api/content/getContentUpAndDownById',
							data: {
								id: res.data.nextId,
								channelId: 36,
								releaseTerrace: 'releasePc'
							}
						}).then(ress => {
							that.showJz.next = {
								id: res.data.nextId,
								title: ress.data.content.title
							}
						})
					} else {
						that.showJz.next = null
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.qwxzs-main {
		margin-top: -33px;
		position: relative;
		width: 100%;
		min-width: 1500px;
		height: 900px;
		background-image: url(../../../static/kpxjt_bg.png);
		background-size: 100% 100%;
		z-index: 1000;
		.top-choose-box {
			position: absolute;
			width: 350px;
			height: 106px;
			display: flex;
			justify-content: space-between;
			top: 50px;
			left: calc(50% - 175px);
			z-index: 998;
			.zswd {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
			.line {
				width: 52px;
				height: 2px;
				margin-top: 50px;
			}
			.zsgl {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
		}
		.bg_4 {
			position: absolute;
			width: 1150px;
			height: 350px;
			top: 227px;
			left: 250px;
			display: flex;
			justify-content: space-between;
			z-index: 997;
			.bg_4_left {
				background-image: url(../../../static/left_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
			.bg_4_middle {
				background-image: url(../../../static/qwxzs_image_4.png);
				background-size: 100% 100%;
				width: 675px;
				height: 386px;
				.bg_4_middle_image {
					width: 167px;
					height: 167px;
					border-radius: 50%;
					position: absolute;
					top: 70px;
					left: 300px;
					img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}
				.bg_4_middle_content {
					position: absolute;
					font-size: 13px;
					color: #FFFFFF;
					top: 60px;
					left: 490px;
					width: 330px;
					text-align: left;
				}
				.ckzsd {
					position: absolute;
					top: 180px;
					right: 330px;
					// cursor: pointer;
				}
			}
			.bg_4_right {
				background-image: url(../../../static/right_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
		}

		.back_home {
			position: absolute;
			width: 102px;
			height: 102px;
			left: 66px;
			bottom: 125px;
			cursor: pointer;
		}
		.left-menu {
			position: absolute;
			width: 170px;
			height: 430px;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			top: 75px;
			left: 55px;
			z-index: 1000;
			.left-menu-item {
				width: 168px;
				height: 65px;
				cursor: pointer;
				text-align: left;
				background-size: 100% 100%;
				img {
					height: 48px;
					margin-top: 9px;
				}
			}
		}
		.left-select {
			position: absolute;
			top: 140px;
			left: 19%;
			width: 1200px;
			height: 360px;
			.kpsp-main {
				margin-top: 150px;
				height: 300px;
				width: 100%;
				display: flex;
				.kpsp-item {
					width: 30%;
					margin: 0 1.6%;
					.kpsp-item-top {
						background-image: url(../../../static/kpsp_bg.png);
						width: 271px;
						height: 281px;
						background-size: 100% 100%;
						position: relative;
						margin: 0 auto;
						cursor: pointer;
						.kpsp-item-top-image {
							position: absolute;
							top: 17px;
							left: 7px;
							height: 257px;
							width: 257px;
							border-radius: 50%;
							cursor: pointer;
						}
						.kpsp-item-top-text {
							position: absolute;
							top: 17px;
							left: 7px;
							height: 257px;
							width: 257px;
							background-color: #000000;
							opacity: 0;
							transition: opacity 0.5s;
							text-align: center;
							align-items: center;
							justify-content: center;
							font-size: 16px;
							border-radius: 50%;
							overflow: hidden;
						}
						.kpsp-item-top-text:hover {
							position: absolute;
							top: 17px;
							left: 7px;
							height: 257px;
							width: 257px;
							background-color: #000000;
							opacity: 0.7;
							transition-duration: 0.5s;
							color: #FFFFFF;
							text-align: center;
							justify-content: center;
							align-items: center;
							font-size: 16px;
							border-radius: 50%;
							overflow: hidden;
						}
					}
					.kpsp-item-top-text-play {
						margin: 100px auto 0;
						width: 24px;
						height: 24px;
						img {
							width: 24px;
							height: 24px;
						}
					}
					.kpsp-item-top-text-title {
						width: 60%;
						margin: 5px auto 0;
						color: #F4DD8F;
						text-align: center;
						font-size: 16px;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
						height: 40px;
						line-height: 40px;
						border-bottom: 2px solid #F4DD8F;
					}
					.kpsp-item-top-text-content {
						width: 70%;
						margin: 5px auto 0;
						color: #F4DD8F;
						text-align: center;
						font-size: 14px;
						height: 40px;
						line-height: 20px;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;
					}
					.kpsp-item-bottom {
						margin: 15px auto;
						padding: 0 10px;
						text-align: center;
						font-size: 13px;
						color: #2D5AC3;
						line-height: 30px;
						height: 30px;
						width: 200px;
						border-radius: 8px;
						background-color: rgba(255, 255, 255, 0.6);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}
				.kpjz-item {
					width: 28%;
					margin: 0 2.6%;
					height: 265px;
					background: #E8F5FD;
					box-shadow: 0px 1px 2px 0px rgba(100,100,100,0.5);
					border-radius: 20px;
					border: 1px solid #F4DD8F;
					cursor: pointer;
					.kpjz-item-top {
						margin: 20px auto 0;
						width: 90%;
						height: 160px;
						img {
							height: 100%;
							width: 100%;
							border-radius: 40px;
						}
					}
					.kpjz-item-bottom {
						width: 90%;
						margin: 5px auto;
						height: 95px;
						display: flex;
						.kpjz-item-bottom-left {
							height: 60px;
							width: 60px;
							margin: 5px 5px 0 0;
							img {
								height: 100%;
								width: 100%;
							}
						}
						.kpjz-item-bottom-right {
							height: 80px;
							width: calc(100% - 80px);
							text-align: left;
							.kpjz-item-bottom-right-1 {
								color: #264EA7;
								font-size: 14px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								font-weight: 500;
							}
							.kpjz-item-bottom-right-2 {
								color: #686868;
								display: flex;
								justify-content: space-between;
								font-size: 9px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								font-weight: 400;
							}
							.kpjz-item-bottom-right-3 {
								color: #686868;
								font-size: 9px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								line-clamp: 2;
								-webkit-box-orient: vertical;
								font-weight: 400;
							}
						}
					}

				}
			}
			.kpsp-details {
				margin-left: 100px;
				width: 1000px;
				height: 500px;
				background-size: 100% 100%;
				background-image: url(../../../static/kpsp_details_bg.png);
				position: relative;
				.back {
					position: absolute;
					right: 40px;
					top: 65px;
					width: 140px;
					height: 80px;
					cursor: pointer;
				}
				.kpsp-details-img {
					position: absolute;
					left: 50px;
					top: 200px;
					width: 350px;
					height: 200px;
					border-radius: 23px;
				}
				.kpsp-details-content {
					position: absolute;
					left: 450px;
					top: 160px;
					width: 520px;
					height: 400px;
					::-webkit-scrollbar {
						width: 6px;
						background-color: #3582fb;
						border-radius: 10px;
					}
					
					/* 滚动槽 */
					::-webkit-scrollbar-track {
						border-radius: 10px;
					}
					
					::-webkit-scrollbar-thumb {
						background-color: #2a68c9;
						border-radius: 10px;
					}
				}
			}
			.kpjz-details {
				width: 100%;
				height: 500px;
				display: flex;
				justify-content: space-between;
				.bg_4_left {
					background-image: url(../../../static/left_image.png);
					background-size: 100% 100%;
					height: 233px;
					width: 191px;
					margin-top: 150px;
					color: #2D5AC3;
					font-size: 23px;
					cursor: pointer;
				}
				.bg_4_left_nomore {
					height: 183px;
					width: 191px;
					margin-top: 150px;
				}
				.bg_4_right_nomore {
					height: 183px;
					width: 191px;
					margin-top: 150px;
				}
				.kpjz-details-middle {
					width: calc(100% - 400px);
					height: 500px;
					background-size: 100% 100%;
					background-image: url(../../../static/kpsp_details_bg.png);
					position: relative;
					.back {
						position: absolute;
						right: 40px;
						top: 65px;
						width: 140px;
						height: 80px;
						cursor: pointer;
					}
					.kpsp-details-img {
						position: absolute;
						left: 50px;
						top: 200px;
						width: 270px;
						height: 180px;
						border-radius: 23px;
					}
					.kpsp-details-content {
						position: absolute;
						left: 350px;
						top: 160px;
						width: 420px;
						height: 400px;
						::-webkit-scrollbar {
							width: 6px;
							background-color: #3582fb;
							border-radius: 10px;
						}
						
						/* 滚动槽 */
						::-webkit-scrollbar-track {
							border-radius: 10px;
						}
						
						::-webkit-scrollbar-thumb {
							background-color: #2a68c9;
							border-radius: 10px;
						}
					}
				}
				.bg_4_right {
					background-image: url(../../../static/right_image.png);
					background-size: 100% 100%;
					height: 233px;
					width: 191px;
					margin-top: 150px;
					color: #2D5AC3;
					font-size: 23px;
					cursor: pointer;
				}
			}
		}
	}
	.video-box {
		width: 100%;
		height: 100%;
		border-radius: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/young/kpxjt.vue